import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    textoTotais: {
        marginTop: theme.spacing(1),
        fontWeight: 600,
    },
    textoSubTotais: {
        fontWeight: 400,
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
    },
    textoTitle: {
        display: 'flex',
        alignItems: 'center'
    },
    textoTitleTotal: {
        marginTop: theme.spacing(1),
        fontWeight: 600
    }
}));
